import React from 'react';
import { Button, red } from 'dma-ui-kit';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { handleCTA } from 'helpers/handlecta';
import ExternalLinkButton from 'components/molecules/ExternalLinkButton';

const Container = styled.div`
    padding: 0 12px;
    margin-bottom: 10px;

    @media (min-width: 768px) {
        padding: 0 24px;
    }

    @media (min-width: 1024px) {
        padding: 0 48px;
    }
`;

const CTAButton = props => {
    const { history, paragraph } = props;
    const { field_cta_link, field_privacy } = paragraph.attributes;

    // Editors can flag a CTA as offsite (field_privacy = true); those show the
    // leaving-the-site notice before opening. Most nodes don't carry the field.
    const showPrivacyNotice = field_privacy === true;

    const variantName = paragraph.attributes.field_variant ? paragraph.attributes.field_variant : 'tertiary';

    const variant = variantName.endsWith('dark') ? variantName.replace('dark', '') : variantName;
    const dark = variantName.endsWith('dark') ? true : false;

    // Handle CTA links
    const followCTA = () => {
        handleCTA(field_cta_link.uri, history, window);
    };

    return (
        <Container>
            {showPrivacyNotice ?
                <ExternalLinkButton
                    href={field_cta_link.uri}
                    label={field_cta_link.title}
                    variant={variant}
                    dark={dark}
                    compact={false}
                    color={red}
                /> :
                <Button variant={variant} dark={dark} color={red} label={field_cta_link.title} onClick={followCTA} />
            }
        </Container>
    );
};

export default withRouter(CTAButton);
